/* eslint-disable */
<template>
  <div class="container-fluid no-padding">
    <div class="row bg-primary-dark">
      <div class="col-md-8 mb-2 mt-2 align-middle">
        <h4>Hat ve ICCID Eşleştirmeleri</h4>
      </div>
      <div class="col-md-4 mb-2 mt-2">
        <button class="btn btn-more-radius btn-success float-right" data-toggle="modal"
          data-target="#modalGetIccid">ICCID Öğren</button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <v-wait for="pairs-loading">
          <template slot="waiting">
            <div class="vue-wait-class">
              <img src="static/loading.svg" />
              <p>Eşleştirmeler yükleniyor...</p>
            </div>
          </template>
          <table class="table table-bordered">
            <thead class="thead-light">
              <tr>
                <th style="width: 5%;" scope="col">#</th>
                <th style="width: 15%;" scope="col">DURUM</th>
                <th style="width: 20%;" scope="col">CİHAZ SERİ NO.</th>
                <th style="width: 20%;" scope="col">ICCID</th>
                <th style="width: 30%;" scope="col">MÜŞTERİ ve ARAÇ</th>
                <th style="width: 15%;" scope="col">EŞLEŞME</th>
              </tr>
            </thead>
            <tbody class="tbody-margin">
              <template v-for="(pair, index) in pairs">
                <tr :key="'trow-first-' + index" :class="{'background-success' : pair.GSMNO}">
                  <td class="align-middle">{{index + 1}}</td>
                  <td class="align-middle">
                    <span v-if="pair.GSMNO" class="btn btn-lg btn-more-radius bg-success">
                      <i class="fas fa-check text-white mr-2"></i>
                      <span class="text-white font-semi-bold">GSM NO. EŞLEŞTİRİLDİ</span>
                    </span>
                    <span v-else>-</span>
                  </td>
                  <td class="align-middle">
                    <div class="justify-content-between">
                      <p class="my-0 font-semi-bold">{{pair.DEVICE_ID}}</p>
                      <small class="text-muted">{{pair.DEVICE_LABEL}}</small>
                    </div>
                  </td>
                  <td v-if="pair.GSMNO" class="align-middle">
                    <div class="justify-content-between">
                      <p class="my-0 font-semi-bold">{{pair.GSMNO}}</p>
                      <small class="text-muted">{{pair.ICCID}}</small>
                    </div>
                  </td>
                  <td v-else class="align-middle">{{pair.ICCID}}</td>
                  <td class="align-middle">
                    <div class="justify-content-between">
                      <p class="my-0 font-semi-bold">{{pair.VEHICLE_NAME}}</p>
                      <small class="text-muted">{{pair.CUSTOMER_TITLE}}</small>
                    </div>
                  </td>
                  <td class="align-middle">{{pair.PAIRDATE_FORMATTED}}</td>
                </tr>
              </template>
            </tbody>
          </table>
        </v-wait>
      </div>
    </div>
    <div class="modal fade bd-example-modal-md" id="modalGetIccid" tabindex="-1"
      role="dialog" aria-labelledby="exportUmeModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
          <div class="modal-header bg-success">
            <h5 class="modal-title text-white" id="trackNumberModalLabel">ICCID Öğren</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span class="text-white" aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <v-wait for="iccid-learning">
              <template slot="waiting">
                <div class="vue-wait-class">
                  <img src="static/loading.svg" />
                  <p>Komut gönderiliyor...</p>
                </div>
              </template>
              <div class="container-fluid">
                <div class="form-row">
                  <label for="price-name">Cihaz Seri Numarası</label>
                  <input type="text" class="form-control" maxlength="15" placeholder="Bir IMEI numarası girin..." v-model="deviceIdLearnToIccid" id="device-id-iccid">
                  <small class="form-text text-muted mt-2">Komut gönderdiğiniz cihazdan, ICCID bilgisi geldiğinde bu bilgi otomatik olarak aşağıdaki listeye eklenecektir. Gelen ICCID bilgisi veritabanı kayıtlarımızla eşleşirse bu bilgi cihaz kayıtlarına da işlenecektir.</small>
                </div>
              </div>
            </v-wait>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-more-radius" data-dismiss="modal">Kapat</button>
            <button type="button" class="btn btn-success btn-more-radius" @click="sendIccidCommand()">Komutu Gönder</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import axios from 'axios'
export default {
  name: 'PairsPage',
  components: {
  },
  data () {
    return {
      pairs: [],
      deviceIdLearnToIccid: null,
      toastOptions: {
        theme: "bubble",
        position: "top-center",
        duration : 4000
      }
    }
  },
  computed: {
    getPersonelId : function() { return this.$store.getters.getPersonelId },
    getSessionId : function() { return this.$store.getters.getSessionId },
    canCreateProduct : function() { return this.$store.getters.userCanCreateProduct },
    canDeleteProduct : function() { return this.$store.getters.userCanDeleteProduct },
    canCalculateProduction : function() { return this.$store.getters.userCanCalculateProduction },
    isCalculationEnabled : function() { return this.selectedProducts.length > 0; }
  },
  methods: {
    getPairs() {
      this.$wait.start('pairs-loading')
      axios.post('/api/stok/hatlar-iccid-pairs?sessionid=' + this.getSessionId + '&searchFilter=',
        { 'SessionId': this.getSessionId, 'SearchFilter': '' })
      .then(response => {
        console.log(response.data)
        this.pairs = response.data
        this.$wait.end('pairs-loading')
      })
      .catch(error => { 
        console.error(error) 
        this.$wait.end('pairs-loading')
      })
    },
    sendIccidCommand() {
      if(!this.regexCheck(this.deviceIdLearnToIccid)) {
        this.$toasted.error('IMEI numarası doğru girilmedi.', this.toastOptions)
        return
      }

      this.$wait.start('iccid-learning')
      axios.post('/api/debug/send-command?sessionId=' + this.getSessionId + '&deviceId=' + this.deviceIdLearnToIccid)
      .then(response => {
        console.log(response.data)
        if(!response.data.HasError)
          this.$toasted.success('Komut gönderildi...', this.toastOptions)
        else
          this.$toasted.error(response.data.ErrorMessage, this.toastOptions)

        $("#modalGetIccid").modal('hide')
        this.$wait.end('iccid-learning')
        this.deviceIdLearnToIccid = null
      })
      .catch(error => { 
        console.error(error) 
        this.$wait.end('iccid-learning')
      })
    },
    regexCheck(imei) {
      const regex = /^\d{15}$/
      let m = regex.exec(imei);
      
      if(m == null || m.length == 0)
        return false
      else
        return true
    },
  },
  mounted() {
    this.getPairs()
    console.log(this.canCreateProduct)
    console.log(this.canDeleteProduct)
    console.log(this.canCalculateProduction)
  }
}
</script>

<style scoped>
  input.btn-more-radius {
    text-indent: 10px;
  }

  .table-row {
    display: block;
    width: 100%;
  }
  
  table, .dropdown-item {
    font-size: .875rem;
  }

  td .btn {
    font-size: .75rem;
  }

  .btn i {
    color: #FFF;
  }

  .btn:hover i {
    color: #FFF !important;
  }

  tr.collapsed-row {
    background: #F0F0F0;
    /*-webkit-box-shadow: inset 0px 5px 30px -15px rgba(102,102,102,1);
    -moz-box-shadow: inset 0px 5px 30px -15px rgba(102,102,102,1);
    box-shadow: inset 0px 5px 30px -15px rgba(102,102,102,1);*/
  }

  span.badge {
    font-size: 100%;
    font-weight: 400;
  }

  .vue-wait-class {
    display: block;
    width: 300px;
    text-align: center;
    margin-top: 30px;
    margin-left: auto;
    margin-right: auto;
  }

  .vue-wait-class img {
    width: 160px;
    height: 160px;
    margin: 10px auto 0 auto;
    clear: both;
  }

  .vue-wait-class p {
    width: 100%;
    text-align: center;
    font-size: 20px;
  }

  .no-padding {
    padding: 0;
    margin: 0;
  }

  .no-padding .row {
    margin: 0;
  }

  .no-padding .row .col-md-12, .no-padding .row .col-md-9, .no-padding .row .col-md-3 {
    margin: 0 !important;
    padding: 0 !important;
  }

  .caption {
    font-size: 15px;
    font-weight: 700;
    color: #e9ecef;
    background-color: #010929;
    vertical-align: center;
    padding: 11px 15px 12px 15px;
  }
  
  .conversation-view {
    display: block;
    position: absolute;
    z-index: 2;
    width: 350px;
    height: 70%;
    left: 3%;
    bottom: 4.5%;
    border: 1px solid #dee2e6;

    -webkit-box-shadow: 0px 10px 30px -4px rgba(200,200,200,1);
    -moz-box-shadow: 0px 10px 30px -4px rgba(200,200,200,1);
    box-shadow: 0px 10px 30px -4px rgba(200,200,200,1); 
  }

  .bubble span {
    display: inline-block;
    min-width: 120px !important;
    width: auto;
    max-width: 70%;
    padding: 6px 20px;
    color: #fff;
    background-color: #007bff;
    border-radius: 30px;
  }

  .bubble small {
    display: block;
    width: 100%;
    margin-left: 8px;
    font-size: 75%;
  }

  .bubble.own span {
    background-color: #e83e8c;
  }

  .bubble.own small {
    margin-right: 8px;
  }

  .modal-body-fixed {
    height: 300px;
    max-height: 300px !important;
    overflow: auto;
  }

  .overflow-y {
    min-height: 100%;
    overflow: auto !important;
  }

  .font-semi-bold {
    font-weight: 500;
  }

  .background-success {
    background-color: rgba(40, 167, 69, 0.07);
    color: #FFF;
  }

</style>


// WEBPACK FOOTER //
// src/components/IccidPairsPage.vue